import React, { useEffect, useState } from "react";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal";
import Cancel from "./../../../../assets/icons/close.png";
import itemImg from "./../../../../assets/icons/menu.png";
import CustomDataGrid from "../../../components/CustomDataGrid/CustomDataGrid.tsx";
import { ToastContainer, toast } from "react-toastify";

import SectionUnlinkModal from '../Unlink/SectionUnlinkModal.tsx';

import axios from "axios";

import {
  Button,
  Grid,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

function SectionArchiveDialog(props) {
  console.log(props);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =
    useState(false);
  const [openArchiveConfirmaitonModal, setopenArchiveConfirmaitonModal] =
    useState(false);
  const [openUnlinkConfirmaitonModal, setopenUnlinkConfirmaitonModal] =
    useState(false);
  const [openDeleteConfirmaitonModal, setopenDeleteConfirmaitonModal] =
    useState(false);

  const [openSectionUnlinkModal, setopenSectionUnlinkModal] =useState(false);
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [dataRows, setDataRows] = useState([]);

  const [selectedDataRows, setSelectedDatarows] = React.useState([]);

  const getselectedData = (props) => {
    console.log(props);
    setSelectedDatarows(props);
  };

  const handleClose = () => {
    props.onClose();
    //props.onHandleAddItem(restaurantId);
    // setKeyword(null)
    setSelectedValue(null);
    setopenMenuCloseConfirmaitonModal(false);
    setopenArchiveConfirmaitonModal(false);
    setOpenDialog(false);
    setRestaurantId([]);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowId(null);
  };

  const {
    open,
    onClose,
    dialogType,
    id,
    cancledRes,
    cancleMenus,
    onToggleSwitch,
    selectedRestaurants,
    openDialog: toggle,
    linkedSections,
    linkdata,
    Status,
    onSuccessClose
  } = props;

  console.log(id);
  console.log(cancledRes);
  console.log(cancleMenus);
  console.log(linkedSections);

  const apiAddress = process.env.REACT_APP_SECRET;

  const [restaurantId, setRestaurantId] = useState([]);

  useEffect(() => {
    if(Status=="Single Archive"){
      if (cancleMenus && cancleMenus.length > 0) {
        let count = 0;
        count++;
        console.log(count);
        let canceledObjs = [];
        let canceledObj = {};
        cancleMenus.forEach((dt) => {
          canceledObj = {
            restaurantId: dt.linkedRestaurantId,
            menuId: dt.linkedMenuId,
            sectionId: dt.linkedSectionId,
            activeSection : null
          };
          canceledObjs.push(canceledObj);
        });
  
        console.log(canceledObjs);
  
        var url = apiAddress + "/api/Section/allsectionarchiveinfo";
  
        axios
          .post(url, canceledObjs)
          .then((response) => {
            console.log(response.data);
  
            var list = [];
            response.data.forEach((dt, i) => {
              var obj = {
                id: i,
                restaurantName: dt.restaurantName,
                menuName: dt.menuName,
                sectionName: dt.sectionName,
                foodName: dt.foodName,
                linkedSectionName: dt.linkedSectionName
              };
              list.push(obj);
            });
            console.log(list);
            setDataRows(list);
          })
          .catch((error) => {
            console.error("Error occurred:", error.response.data);
          });
      }
    }
    else if(Status=="Bulk Archive"){
      if (cancleMenus && cancleMenus.length > 0) {
        let count = 0;
        count++;
        console.log(count);
        let canceledObjs = [];
        let canceledObj = {};
        cancleMenus.forEach((dt) => {
          canceledObj = {
            restaurantId: dt.linkedRestaurantId,
            menuId: dt.id,
            sectionId: dt.linkedSectionId,
            activeSection : dt.activeSection
          };
          canceledObjs.push(canceledObj);
        });
  
        console.log(canceledObjs);
  
        var url = apiAddress + "/api/Section/allsectionarchiveinfo";
  
        axios
          .post(url, canceledObjs)
          .then((response) => {
            console.log(response.data);
  
            var list = [];
            response.data.forEach((dt, i) => {
              var obj = {
                id: i,
                restaurantName: dt.restaurantName,
                menuName: dt.menuName,
                sectionName: dt.sectionName,
                foodName: dt.foodName,
                linkedSectionName: dt.linkedSectionName
              };
              list.push(obj);
            });
            console.log(list);
            setDataRows(list);
          })
          .catch((error) => {
            console.error("Error occurred:", error.response.data);
          });
      }
    }
  }, [cancleMenus]);

  const archiveSubmit = () => {


    if(Status=="Single Archive"){

      if (cancleMenus && cancleMenus.length > 0) {

        let canceledObjs=[]
        let canceledObj={}

        cancleMenus.forEach((dt) => {
          canceledObj={
            restaurantId: dt.linkedRestaurantId,
            menuId: dt.linkedMenuId,
            sectionId : dt.linkedSectionId,
          }
          canceledObjs.push(canceledObj)
          console.log(canceledObjs);
        });

        var url = apiAddress + '/api/Section/sectionarchived';

        axios.put(url, canceledObjs).then((response) => {
          console.log(response.data);
            toast.success("Section Succesfully Archived", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            console.log(canceledObjs)
            props.onHandleArchiveItem(canceledObjs);
            setSelectedValue(null);
            setopenMenuCloseConfirmaitonModal(false);
            setopenArchiveConfirmaitonModal(false);
            setOpenDialog(false);
            //setRestaurantId([]);
            //cancledRes=[];
        });
    }
  }
  else if(Status=="Bulk Archive"){
    if (cancleMenus && cancleMenus.length > 0) {

      let canceledObjs=[]
      let canceledObj={}
      cancleMenus.forEach((dt) => {
        canceledObj={
          restaurantId: dt.linkedRestaurantId,
          menuId: dt.id,
          sectionId : dt.linkedSectionId,
          activeSection : dt.activeSection
        }
        canceledObjs.push(canceledObj)
        console.log(canceledObjs);
      });


      var url = apiAddress + '/api/Section/sectionBulkarchived'; 

      axios.put(url, canceledObjs).then((response) => {
      console.log(response.data);
        toast.success("Section Succesfully Archived", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        console.log(canceledObjs)
        props.onHandleArchiveItem();
        setSelectedValue(null);
        setopenMenuCloseConfirmaitonModal(false);
        setopenArchiveConfirmaitonModal(false);
        setOpenDialog(false);
        //setRestaurantId([]);
        //cancledRes=[];
        props.onSuccessClose()
    });
    }
  }
  };

  const unlinkSubmit = () => {

    if(Status=="Bulk Archive"){
      if (cancleMenus && cancleMenus.length > 0) {
        console.log(cancleMenus);

        let canceledObjs=[]
        let canceledObj={}

        cancleMenus.forEach((dt) => {
          canceledObj={
            restaurantId: dt.linkedRestaurantId,
            menuId: dt.id,
            sectionId : dt.linkedSectionId,
            activeSectionId : dt.activeSection
          }
          canceledObjs.push(canceledObj)
          console.log(canceledObjs);
        });
          var url = apiAddress + "/api/Section/SectionUnlinkFromMenu";

          axios.put(url,canceledObjs).then((response) => {
            console.log(response.data);
            toast.success("Sections Succesfully Unlinked", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
          });
          console.log()
          props.onHandleArchiveItem();
          setSelectedValue(null);
          setopenMenuCloseConfirmaitonModal(false);
          setopenArchiveConfirmaitonModal(false);
          setOpenDialog(false);
          //setRestaurantId([]);
          //cancledRes=[];
      });
    }
    }
}
  const deleteSubmit = () => {

    if(Status=="Single Archive"){
      if (cancleMenus && cancleMenus.length > 0) {

        let deleteSectionIds=[]
  
        cancleMenus.forEach((dt) => {
          deleteSectionIds.push(dt.linkedSectionId)    
        });
        console.log(deleteSectionIds);

        var url = apiAddress + "/api/Section/deletesection?status=0";
  
        axios.put(url, deleteSectionIds).then((response) => {
          console.log(response.data);
          toast.success("Section Succesfully Deleted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
        console.log()
        props.onHandleArchiveItem();
        setSelectedValue(null);
        setopenMenuCloseConfirmaitonModal(false);
        setopenArchiveConfirmaitonModal(false);
        setOpenDialog(false);
        //setRestaurantId([]);
        //cancledRes=[];
        });
      }
    }
    else if(Status=="Bulk Archive"){
      if (cancleMenus && cancleMenus.length > 0) {
  
        let canceledObjs=[]
        let canceledObj={}
        cancleMenus.forEach((dt) => {
          canceledObj={
            restaurantId: dt.linkedRestaurantId,
            menuId: dt.id,
            sectionId : dt.linkedSectionId,
            activeSection : dt.activeSection
          }
          canceledObjs.push(canceledObj)
          console.log(canceledObjs);
        });
  
  
        var url = apiAddress + "/api/Section/sectionBulkDelete";
  
        axios.put(url, canceledObjs).then((response) => {
          console.log(response.data);
          toast.success("Section Succesfully Deleted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
        console.log()
        props.onHandleArchiveItem();
        setSelectedValue(null);
        setopenMenuCloseConfirmaitonModal(false);
        setopenArchiveConfirmaitonModal(false);
        setOpenDialog(false);
        //setRestaurantId([]);
        //cancledRes=[];
      });
      }
    }
}

const handleSectionUnlink = () => {
    
  if(Status=="Single Archive"){
    setopenSectionUnlinkModal(true)
  }
  else if(Status=="Bulk Archive"){
    setopenUnlinkConfirmaitonModal(true)
  }

}
const handleunlinkModalClose = () => {
  setopenSectionUnlinkModal(false)
  props.onClose();
}
    


  return (
    <div>
      <React.Fragment>
        <Dialog maxWidth={"sm"} open={props.open} onClose={handleClose}>
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />
          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"Do you want to Delete this Section?"}
            open={openDeleteConfirmaitonModal}
            onyes={deleteSubmit}
            close={() => {
              setopenDeleteConfirmaitonModal(false);
            }}
          />
          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"Do you want to Unlink this Section?"}
            open={openUnlinkConfirmaitonModal}
            onyes={unlinkSubmit}
            close={() => {
              setopenUnlinkConfirmaitonModal(false);
            }}
          />

          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"Do you want to Archive this Section?"}
            open={openArchiveConfirmaitonModal}
            onyes={archiveSubmit}
            close={() => {
              setopenArchiveConfirmaitonModal(false);
            }}
          />
          <Grid container>
            <Grid item xs={9}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <div>
                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                  </div>

                  <span style={{ color: "#2a7fd4" }}>
                    GoTaste :- {dialogType}
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            <Grid item xs={3}>
              <DialogActions>
                <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent>
            {/* {dataRows.map((dt,i)=>(
            <span>
            <p>This menu {dt.menuName} will be disabled For these Restaurant's</p>
          </span>
            ))} */}
            {
              dataRows.length > 0 && Status=="Single Archive" && (
                <span>
                  <p>
                     
                  <b>{`{${dataRows.map(row => row.sectionName).join(', ')}}`}</b> in <b>{`{${dataRows.map(row => row.menuName).join(', ')}}`}</b> will be removed from the restaurant below
                  </p>
                </span>
              )
            }
            {
              dataRows.length > 0 && Status=="Bulk Archive" && (
                <span>
                  <p>
                    {dataRows.length === 1 ? (
                      <>
                        <b>{`{${dataRows.length}}`}</b> section and related section in <b>{`{${dataRows.length}}`}</b> menu will be removed from the restaurant below
                      </>
                    ) : (
                      <>
                        <b>{`{${dataRows.length}}`}</b> section and related section in <b>{`{${dataRows.length}}`}</b> menu will be removed from the restaurant below
                      </>
                    )}
                  </p>
                </span>
              )
            }

            {/* <CustomDataGrid columns={columns} dataRows={dataRows}/> */}

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align='center'>Restaurant Name</TableCell>
                  <TableCell align='center'>Related Menu</TableCell>
                  {Status == "Bulk Archive" && (
                  <TableCell align='center'>Related Section</TableCell>
                  )}
                  <TableCell align='center'>Related Items</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataRows.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align='center'>{row.restaurantName}</TableCell>
                    <TableCell align='center'>{row.menuName}</TableCell>             
                    {Status == "Bulk Archive" && row?.linkedSectionName !==null && (
                    <TableCell align='center'>{row.sectionName+','+ row.linkedSectionName}</TableCell>
                    )}
                    {Status == "Bulk Archive" && row?.linkedSectionName ==null && (
                    <TableCell align='center'>{row.sectionName}</TableCell>
                    )}
                    <TableCell align='center'>{row.foodName}</TableCell>
                    
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setopenArchiveConfirmaitonModal(true)}
              color="error"
            >
              Archive
            </Button>
            <Button
              onClick={() => setopenDeleteConfirmaitonModal(true)}
              color="error"
            >
              Delete
            </Button>
            <Button
              onClick={handleSectionUnlink}
              color="error"
            >
              Unlink Section
            </Button>
            <Button
              onClick={() => setopenMenuCloseConfirmaitonModal(true)}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      <SectionUnlinkModal 
        open={openSectionUnlinkModal}
        dialogType={'Section Unlink'}
        onClose={handleunlinkModalClose}
        linkedSection={cancleMenus}
      />
    </div>
  );
}

export default SectionArchiveDialog;
